import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { StatusPill } from '../ui/StatusPill';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { projects } from '../../data/projects';
export function FeaturedProjects() {
  const featuredProjects = projects.filter(p => p.featured).slice(0, 3);
  return <section className="py-20 bg-ivory" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4" data-id="element-108">
        <SectionHeading title="Featured Projects" subtitle="Transformative initiatives driving sustainable development across Africa" data-id="element-109" />

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-110">
          {featuredProjects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-111">
              <Card hover className="h-full flex flex-col" data-id="element-112">
                <div className="mb-4" data-id="element-113">
                  <StatusPill status={project.status} data-id="element-114">
                    {project.status.toUpperCase()}
                  </StatusPill>
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-115">
                  {project.title}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-3" data-id="element-116">
                  <MapPinIcon size={16} data-id="element-117" />
                  <span data-id="element-118">{project.countries.join(', ')}</span>
                </div>
                <p className="text-gray-600 mb-4 flex-1" data-id="element-119">
                  {project.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-border" data-id="element-120">
                  <span className="text-sm font-medium text-au-green" data-id="element-121">
                    {project.sector}
                  </span>
                  <span className="text-sm font-bold text-charcoal" data-id="element-122">
                    {project.budget}
                  </span>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-123">
          <Link to="/projects" data-id="element-124">
            <Button variant="secondary" className="flex items-center gap-2 mx-auto" data-id="element-125">
              View All Projects
              <ArrowRightIcon size={20} data-id="element-126" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}